import { createContext, useCallback, useEffect, useState } from 'react';
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";
import Web3 from 'web3';
import { createWeb3 } from '../../blockchain/utils';
import { rpcUrls} from "../../blockchain/constants";

import { useMoralis } from "react-moralis";

interface IWeb3ModalContext {
  web3: Web3 | null;
  connect: () => void;
  disconnect: () => void;
  account: string | null;
  chainId: number | null;
  networkId: number | null;
  connected: boolean;
}

export const Web3ModalContext = createContext<IWeb3ModalContext>({
  web3: null,
  connect: () => {},
  disconnect: () => {},
  account: null,
  chainId: null,
  networkId: null,
  connected: false

});

const Web3ModalProvider = ({ children }) => {

  const {isAuthenticated, authenticate,isAuthenticating,user,logout } = useMoralis();

  const [web3Modal, setWeb3Modal] = useState<Web3Modal | null>(null);
  const [web3, setWeb3] = useState<Web3 | null>(null);
  const [account, setAccount] = useState<string | null>(null);
  const [chainId, setChainId] = useState<number | null>(null);
  const [networkId, setNetworkId] = useState<number | null>(null);
  const [connected, setConnected] = useState<boolean>(false);

  useEffect(() => {
    const providerOptions = {

      walletconnect: {
        package: WalletConnectProvider,
        options: {
          rpc: {
            1: rpcUrls[1],
            56: rpcUrls[56],
            97: rpcUrls[97],
            1337: rpcUrls[1337],
          },
          network: 'binance',
        }
      }
    };
  
    const _web3Modal = new Web3Modal({
      cacheProvider: true, // optional
      providerOptions, // required
      disableInjectedProvider: false, // optional. For MetaMask / Brave / Opera.
    });
  
    setWeb3Modal(_web3Modal);
  }, [])

  const resetWeb3 = useCallback(() => {
    setWeb3(null);
    setAccount(null);
    setChainId(null);
    setNetworkId(null);
    setConnected(false);
  }, [])

  const subscribeProvider = useCallback(async (_provider: any, _web3: Web3) => {
    if (!_provider.on)
      return;

    _provider.on("close", () => {
      resetWeb3();
    });
    _provider.on("accountsChanged", async (accounts: string[]) => {
      setAccount(accounts[0]);
    });
    _provider.on("chainChanged", async (chainId: number) => {
      console.log("Chain changed: ", chainId);
      const networkId = await _web3.eth.net.getId();
      setChainId(chainId);
      setNetworkId(networkId);
    });

    _provider.on("networkChanged", async (networkId: number) => {
      const chainId = await _web3.eth.getChainId();
      setChainId(chainId);
      setNetworkId(networkId);
    });
  }, [resetWeb3])

  const connectwithWeb3 = (async () => {

   // console.log(web3Modal);
        if (!web3Modal)
          return;
    
        const _provider = await web3Modal.connect();
       // console.log(_provider);
        if (_provider === null) 
          return;
        
        const _web3 = createWeb3(_provider);
        setWeb3(_web3);
    
        await subscribeProvider(_provider, _web3);
        
        const accounts = await _web3.eth.getAccounts();
        const _account = accounts[0];
        //console.log(_account);
        const _networkId = await _web3.eth.net.getId();
        const _chainId = await _web3.eth.getChainId();
    
        //let contract = new web3.eth.Contract(Coinracer,tokenAddress);
        var balance = await _web3.eth.getBalance(_account); //Will give value in.
        //console.log(balance);
    
        
    
        setAccount(_account);
        setNetworkId(_networkId);
        setChainId(_chainId);
        setConnected(true);
      
  });

  const connect = useCallback(async () => {
   // console.log(isAuthenticated);

    if(isAuthenticated){
      if(user)
      localStorage.setItem("flcpe", user.id);
      console.log("alogin");
      console.log(user!.get("ethAddress"));
      logout();
     if(user!.get("ethAddress")){
      connectwithWeb3();
     }
    }
    if (!isAuthenticated) {
      
      await authenticate().then(function (user) {
        console.log("login-");
        if(user)
        localStorage.setItem("flcpe", user.id);
        if(user!.get("ethAddress")){
          connectwithWeb3();
         }
      })
      .catch(function (error) {
        localStorage.setItem("hjk", "0");
        console.log(error);
      });
 
    }
    
   
    
  }, [web3Modal, subscribeProvider]);

  useEffect(() => {
    if (web3Modal && web3Modal.cachedProvider) {
      connect();
    }
  }, [web3Modal, connect])

  const disconnect = useCallback(async () => {
    if (web3 && web3.currentProvider) {
      const _provider: any = web3.currentProvider;
      if (_provider.close)
        await _provider.close();
    }
    if (web3Modal) {
      await web3Modal.clearCachedProvider();
    }
    
    resetWeb3();

  }, [web3Modal, web3, resetWeb3])

  return (
    <Web3ModalContext.Provider 
      value={{ 
        web3, 
        connect,
        disconnect,
        account,
        networkId,
        chainId,
        connected
      }}>
      {children}
    </Web3ModalContext.Provider>
  )
}

export default Web3ModalProvider;